export default "__VITE_ASSET__R7MEOxCL__"